module.exports = __webpack_public_path__ + "static/btn_042.49f9cc19.png";